import React from 'react';
import { Typography } from '@mui/material';

import { customHeapEvent } from 'utils/heap';

import { PRIME_CDN_URL } from '../../../../constants/environments';

import type { IntegrationsCheckboxCardProps } from './IntegrationsCheckboxCard';
import { IntegrationsCheckboxCard } from './IntegrationsCheckboxCard';

const LEARN_MORE_URL = 'https://support.skyslope.com/hc/en-us/articles/31497519011099-RealSatisfied-SkySlope-FAQ';

export function RealSatisfiedCheckboxCard(props: IntegrationsCheckboxCardProps) {
  React.useEffect(() => {
    customHeapEvent('Forms - Onboard Modal - RealSatisfied Shown');
  }, []);
  return (
    <IntegrationsCheckboxCard {...props}>
      <img
        src={`${PRIME_CDN_URL}/prime/images/RealSatisfiedLogo.svg`}
        id="realsatisfiedLogo"
        alt="Real Satisfied"
        width="auto"
        height={22}
      />

      <Typography className="text-sm text-left text-grey-800">
        Collect feedback, share reviews, and grow your business with RealSatisfied&apos;s insights{' '}
        <a target="_blank" rel="noopener" href={LEARN_MORE_URL}>
          Learn More.
        </a>
      </Typography>
    </IntegrationsCheckboxCard>
  );
}
